import { createSelector } from 'reselect';
const getProductComparison = (state) => state.productComparison;
export const makeGetProductComparisonState = () => createSelector(getProductComparison, (products) => products);
